export interface IPreReversalReport {
    id: number,
    donorCenter: string,
    rdnCenterAlias: string,
    donorCenterId: number,
    donorId: number,
    donorAlias: string,
    recipientCenter: string,
    recipientCenterId: number,
    reversalResponsible: number,
    recipientId: number,
    recipientAlias: string,
    accepted: string,
    reversed: string,
    daysET: number,
    rejectedReason: string,
    rejectedReasonDetail: string,
    byInitials: string,
    swap: number,
    cluster: number,
    position: number
}